import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex items-center mb-4" };
const _hoisted_2 = {
    key: 0,
    class: "admin-form panel-form"
};
const _hoisted_3 = { class: "form-group text-sm" };
const _hoisted_4 = { class: "col-span-6 xl:col-span-4" };
const _hoisted_5 = { class: "mt-2" };
const _hoisted_6 = ["href"];
const _hoisted_7 = { class: "col-span-6 xl:col-span-4" };
const _hoisted_8 = { class: "mt-2" };
const _hoisted_9 = { class: "col-span-6 xl:col-span-4" };
const _hoisted_10 = { class: "mt-2" };
const _hoisted_11 = { class: "col-span-6 xl:col-span-4" };
const _hoisted_12 = { class: "mt-2" };
const _hoisted_13 = { class: "admin-form panel-form" };
const _hoisted_14 = { class: "form-group" };
const _hoisted_15 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_16 = ["value"];
const _hoisted_17 = {
    key: 1,
    class: "text-sm text-slate-600"
};
const _hoisted_18 = {
    key: 2,
    class: "input-error-message text-sm"
};
const _hoisted_19 = { class: "mt-2" };
const _hoisted_20 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_21 = { class: "mt-2" };
const _hoisted_22 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_23 = { class: "flex px-1" };
const _hoisted_24 = { class: "flex-1" };
const _hoisted_25 = {
    key: 0,
    class: "error-message"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_Loading = _resolveComponent("Loading");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Order Campaign Codes", -1)),
            _createElementVNode("nav", null, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.form.navigation.goBack && _ctx.form.navigation.goBack(...args))),
                    type: "button",
                    class: "alt"
                }, "Go Back")
            ])
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "top-help-block" }, [
            _createElementVNode("div", null, [
                _createElementVNode("span", { class: "text-brand-600" }, "*"),
                _createTextVNode(" denotes required field ")
            ])
        ], -1)),
        (_ctx.form.isLoaded())
            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                _cache[11] || (_cache[11] = _createElementVNode("aside", null, [
                    _createElementVNode("h2", { class: "font-medium text-lg" }, "Campaign"),
                    _createElementVNode("p", null, " The campaign details, any codes order will be limited to this campaign. ")
                ], -1)),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", { for: "value" }, "Name", -1)),
                        _createElementVNode("div", _hoisted_5, [
                            _createTextVNode(_toDisplayString(_ctx.form.campaign.data.name) + " <", 1),
                            _createElementVNode("a", {
                                href: _ctx.form.campaign.data.endpoint,
                                target: "_blank"
                            }, _toDisplayString(_ctx.form.campaign.data.endpoint), 9, _hoisted_6),
                            _cache[6] || (_cache[6] = _createTextVNode("> ", -1))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "value" }, "Start Date", -1)),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.f.formatDate(_ctx.form.campaign.data.start_date)) + " (" + _toDisplayString(_ctx.f.getTimeZone()) + ") ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", { for: "value" }, "End Date", -1)),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.form.campaign.data.end_date ? _ctx.f.formatDate(_ctx.form.campaign.data.end_date) + ' (' + _ctx.f.getTimeZone() + ')' : 'No End Date'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { for: "value" }, "Currency", -1)),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.form.campaign.data.currency), 1)
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.form.isLoaded())
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                action: "#",
                method: "post",
                enctype: "multipart/form-data",
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.form.create()), ["prevent"]))
            }, [
                _createElementVNode("section", _hoisted_13, [
                    _cache[18] || (_cache[18] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Order"),
                        _createElementVNode("p", null, " Place an order for Chooza codes, these codes will be assigned and use in this campaign. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('sku') }])
                        }, [
                            _cache[15] || (_cache[15] = _createElementVNode("label", { for: "sku" }, [
                                _createTextVNode("Chooza Product"),
                                _createElementVNode("span", { class: "req-asterisk" }, "*")
                            ], -1)),
                            (_ctx.form.hasProducts())
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _withDirectives(_createElementVNode("select", {
                                        name: "sku",
                                        id: "sku",
                                        required: "",
                                        "aria-required": "true",
                                        autocomplete: "off",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.form.data.sku) = $event))
                                    }, [
                                        _cache[12] || (_cache[12] = _createElementVNode("option", { value: null }, "Select Product", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.getProducts(), (product) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                value: product.sku
                                            }, _toDisplayString(product.name), 9, _hoisted_16));
                                        }), 256))
                                    ], 512), [
                                        [_vModelSelect, _ctx.form.data.sku]
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_17, [
                                    _cache[14] || (_cache[14] = _createTextVNode(" There are no products available for your account, please perform a product synchronisation by ", -1)),
                                    _createVNode(_component_router_link, {
                                        to: { name: 'admin.account.manage', params: { slug: _ctx.form.account } }
                                    }, {
                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                _createTextVNode("Managing your Account", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["to"])
                                ])),
                            (_ctx.form.fieldHasErrors('sku'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.form.getFieldError('sku')), 1))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('value') }])
                        }, [
                            _cache[16] || (_cache[16] = _createElementVNode("label", { for: "value" }, [
                                _createTextVNode("Value"),
                                _createElementVNode("span", { class: "req-asterisk" }, "*")
                            ], -1)),
                            _createElementVNode("div", _hoisted_19, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    name: "value",
                                    id: "value",
                                    required: "",
                                    "aria-required": "true",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.form.data.value) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.form.data.value]
                                ])
                            ]),
                            (_ctx.form.fieldHasErrors('value'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.form.getFieldError('value')), 1))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('quantity') }])
                        }, [
                            _cache[17] || (_cache[17] = _createElementVNode("label", { for: "quantity" }, [
                                _createTextVNode("Quantity"),
                                _createElementVNode("span", { class: "req-asterisk" }, "*")
                            ], -1)),
                            _createElementVNode("div", _hoisted_21, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    name: "quantity",
                                    id: "quantity",
                                    required: "",
                                    "aria-required": "true",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.form.data.quantity) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.form.data.quantity]
                                ])
                            ]),
                            (_ctx.form.fieldHasErrors('quantity'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.form.getFieldError('quantity')), 1))
                                : _createCommentVNode("", true)
                        ], 2)
                    ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                        (_ctx.form.noFieldErrors())
                            ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.form.getErrorMessage()), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("div", null, [
                        _createElementVNode("button", { type: "submit" }, "Place Order")
                    ], -1))
                ])
            ], 32))
            : (_openBlock(), _createBlock(_component_Loading, { key: 2 }))
    ]));
}
